import '../assets/css/projects.css';
import { useState, useRef } from 'react';
import Gallery from './Gallery';
import Button from './Button';
const projects = [
    {
        title: "PMNE (Project Monitoring And Evaluation) / QAFF",
        description: "Developed a dynamic platform for project management and evaluation, featuring custom form builders, survey and quiz modules, and enhanced data analysis capabilities.",
        technologies: "HTML, CSS, JavaScript, React.js, PHP, Codeigniter, RESTful APIs, MySQL.",
        link: "https://qaffdashboard.com/QAFF/",
        details: " Designed  and  implemented  new  features,  including  survey  and  quiz  forms,  to gather  employee  feedback  and  assess  project  performance,  resulting  in improved data collection and analysis capabilities. Developed  a  dynamic  form  builder  using  JavaScript  and  React  JS,  allowing organizations  to  create  customized  forms  for  data  collection,  with  features including  drag-and-drop  form  building  and  the  ability  to  create  fixed,  activity, survey, and quiz forms. Utilized  technologies latest  to  build  a  robust  and  scalable  platform  that  met  the  needs  of organizations across a range of industries. Collaborated  with  cross-functional  teams  to  gather  requirements,  design  new features, and ensure timely delivery of high-quality code."
    },
    {
        title: "Uganda DAT TB Platform",
        description: "Developed a web application for monitoring and managing TB patient data, including test reports, adherence tracking, and treatment adjustments, with an adherence calendar for doctors to optimize care plans.",
        technologies: "HTML, CSS, JavaScript, PHP, Codeigniter, RESTful APIs, MySQL.",
        link: "https://adhere.global/universalTBplatform/",
        details: " Created  a  digital  platform  for  registering,  uploading  test  reports,  patient  report adherence  by  video,  dot,  pill  box,  monitoring  patient  adherence  to  medication through adherence calendar. Designed  an  adherence  calendar  for  doctors  to  monitor  patient  adherence reporting and make necessary adjustments to the treatment plan. "
    },
    {
        title: "Geo Data Visualisation Tool",
        description: "Designed and developed a web application for visualizing and analyzing geospatial data, featuring tools for drawing shapes, data analysis, and predictions. Integrated API services and implemented a responsive, scalable system.",
        technologies: "HTML, CSS, JavaScript, OpenLayer, PHP, Codeigniter, RESTful APIs, PostgreSQL, GeoServer.",
        link: "#",
        details: "Created  an  organization  and  project  management  system  with  data  source URL  (API  service)  integration  for  easy  visualization  and  analysis  of  geospatial data. Developed  features  such  as  drawing  shapes,  data  analysis,  and  prediction according to data, highlighting or selecting particular areas on the map. Successfully  overcame  technical  challenges  and  met  project  milestones  on time  Showcased  skills  in  software  development,  problem-solving,  teamwork, and communication. "
    }
];


const Projects = () => {

    const [selectedProject, setSelectedProject] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    const imgVidRef = useRef(null);

    const openModal = (project) => {
        setSelectedProject(project);
    };

    const closeModal = () => {
        setSelectedProject(null);
    };

    const goToNextSlide = () => {
        // if (selectedProject && currentSlide < selectedProject.media.length - 1) {
        if (selectedProject) {
            imgVidRef.current.style.transform = "translateX(-100%)";
            setTimeout(() => {
                setCurrentSlide((currentSlide + 1) > (selectedProject.media.length - 1) ? 0 : (currentSlide + 1));

                // Reset the position to slide in
                imgVidRef.current.style.transform = "translateX(100%)";

                setTimeout(() => {
                    imgVidRef.current.style.transform = "translateX(0)";
                }, 50); // Small delay to ensure smooth animation
            }, 500);

        }
    };

    const goToPreviousSlide = () => {
        if (selectedProject) {
            imgVidRef.current.style.transform = "translateX(100%)";
            setTimeout(() => {
                setCurrentSlide((currentSlide - 1) < 0 ? (selectedProject.media.length - 1) : (currentSlide - 1));

                // Reset the position to slide in
                imgVidRef.current.style.transform = "translateX(-100%)";

                setTimeout(() => {
                    imgVidRef.current.style.transform = "translateX(0)";
                }, 50);
            }, 500);

        }
    };


    return (
        <>
            <h1 className="heading section-title">My Projects</h1>

            <div className="projects_parent_container">

                <section className="projects-section">

                    <div className="projects-container">
                        {projects.map((project, index) => (
                            <div className="project-card" key={index}>
                                <h3 className="project-title">{project.title}</h3>
                                <p className="project-description">{project.description}</p>
                                <p className="project-tech">Technologies: {project.technologies}</p>
                                {/* <a href={project.link} className="project-link">View Project</a> */}
                                {/* <button className="project-link project_btn" onClick={() => openModal({ ...project, projectIndex: index })}>
                                    View Project
                                </button> */}
                                <Button calassName="project_btn" text="View Project" color="red" onClickHandler={() => openModal({ ...project, projectIndex: index })} />
                                {/* <br /> */}
                                {project.link == "#" &&
                                    // <span className={"project-link link_btn disabled_link"}>Link</span>
                                    <Button calassName="link_btn" text="Link" color="gray" />

                                }
                                {project.link != "#" &&
                                    // <a href={project.link} className={"project-link link_btn"} target="_blank">Link</a>
                                    <Button calassName="link_btn" text="Link" color="blue" url={project.link} />

                                }
                            </div>
                        ))}
                    </div>

                    {selectedProject && (
                        <div className="modal-overlay" onClick={closeModal}>
                            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                <span className="close-modal" onClick={closeModal}>&times;</span>
                                <h2 className="model-heading">{selectedProject.title}</h2>
                                <p className="model-short-intro">{selectedProject.description}</p>

                                <div className="slider-container">


                                    {/* <button className="slider-button prev" onClick={goToPreviousSlide}>&#10094;</button>
                                    {selectedProject.media[currentSlide].type === "image" ? (
                                        <>
                                            <div className="slide">
                                                <img
                                                    src={selectedProject.media[currentSlide].src}
                                                    alt={selectedProject.title}
                                                    className="project-image"
                                                    ref={imgVidRef}
                                                />
                                            </div>
                                            <div className="slide">
                                                <img
                                                    src={selectedProject.media[currentSlide].src}
                                                    alt={selectedProject.title}
                                                    className="project-image"
                                                    ref={imgVidRef}
                                                />
                                            </div>
                                            <div className="slide">
                                                <img
                                                    src={selectedProject.media[currentSlide].src}
                                                    alt={selectedProject.title}
                                                    className="project-image"
                                                    ref={imgVidRef}
                                                />
                                            </div>
                                        </>
                                    ) : (

                                        <div className="slide">
                                            <video controls className="project-video" ref={imgVidRef}>
                                                <source src={selectedProject.media[currentSlide].src} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>


                                    )}
                                    <button className="slider-button next" onClick={goToNextSlide}>&#10095;</button> */}

                                    <Gallery projectIndex={selectedProject.projectIndex} />

                                </div>

                                <p className="model-details">{selectedProject.details}</p>

                            </div>                    </div>)}


                </section>
            </div>
        </>
    );
};

export default Projects;
